import { useAuthUser } from 'react-auth-kit';
import { Button } from 'src/components';

import styles from '../styles.module.scss';
import BaseLayout from './BaseLayout';

type IntroProps = {
  onStartOnboarding: () => void;
};

const Intro = ({ onStartOnboarding }: IntroProps) => {
  const auth = useAuthUser();
  const authenticatedUser = auth();
  const isAdmin = authenticatedUser?.role === 'ADMIN';

  return (
    <BaseLayout>
      <h1>Hello {authenticatedUser?.username && <span>{authenticatedUser?.username}</span>}, welcome to FileSpin!</h1>
      <p>
        {isAdmin
          ? "Let's set up your organization's asset management in a few quick steps."
          : "Let's get you familiar with the tools you'll use every day."}
      </p>

      <Button onClick={onStartOnboarding}>
        {isAdmin ? 'Start setup wizard' : 'Get started'}
      </Button>
    </BaseLayout>
  );
};

export default Intro;
